import { getServiceInfo, getAgreement } from '@/services/api'

const service = {
  state: () => ({
    statusList: null,
    policyList: null,
    agreement: null,
  }),
  mutations: {
    // 상태 정보 설정
    setStatusList(state, statusList) {
      state.statusList = statusList
    },
    // 정책 정보 설정
    setPolicyList(state, policyList) {
      state.policyList = policyList
    },
    // 약관 정보 설정
    setAgreement(state, agreement) {
      state.serviceInfo = agreement
    },
  },
  actions: {
    // API 헤더 설정
    async setApiHeader() {
      // console.log('setApiHeader')
      if (this.state.auth.currentUser) {
        this._vm.$axios.defaults.headers.common['Authorization'] = 'bearer ' + this.state.auth.currentUser._lat
      } else {
        if ('Authorization' in this._vm.$axios.defaults.headers.common)
          delete this._vm.$axios.defaults.headers.common['Authorization']
      }
    },
    // 서비스 정보 로드
    async getServiceInfo() {
      try {
        let result = await getServiceInfo(this._vm)

        if (result.statusCode === '200') {
          let statusList = await result.body.filter((info) => info.serviceType === 'STATUS')[0]
          let policyList = await result.body.filter((info) => info.serviceType === 'POLICY')[0]

          delete statusList['serviceType']
          delete policyList['serviceType']

          await this.commit('setStatusList', statusList)
          await this.commit('setPolicyList', policyList)
        }
      } catch (error) {
        console.log(error.response.status, error.response.data)
      }
    },
    // 약관 정보 로드
    async getAgreement() {
      try {
        let result = await getAgreement(this._vm)

        if (result.statusCode === '200') this.commit('setAgreement', result.body)
      } catch (error) {
        console.log(error.response.status, error.response.data)
      }
    },
  },
  getters: {
    // 상태 정보
    statusList(state) {
      return state.statusList
    },
    // 정책 정보
    policyList(state) {
      return state.policyList
    },
    // 약관 정보
    agreement(state) {
      return state.agreement
    },
  },
}

export default service
